import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "embedded-add-to-cart" }
const _hoisted_2 = { class: "embedded-add-to-cart__controls" }
const _hoisted_3 = { class: "embedded-add-to-cart__add-to-cart-wrapper" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "embedded-add-to-cart__fulfillment-usps" }
const _hoisted_6 = { class: "embedded-add-to-cart__fulfillment-usp" }
const _hoisted_7 = { class: "embedded-add-to-cart__fulfillment-usps" }
const _hoisted_8 = { class: "embedded-add-to-cart__fulfillment-usp" }

import { computed, inject } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';

import Divider from '../Divider.vue';
import SizeDropdown from './SizeDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbeddedAddToCart',
  setup(__props) {

const addToCartContext = inject('addToCartContext') as any;

const { websiteText } = useWebsiteTexts();

const selectedSizeHasStock = computed(
  () => addToCartContext.selectedSizeHasStock.value,
);

const isComingSoon = computed(() => addToCartContext.isComingSoon);

/* eslint no-confusing-arrow: "off" */
const buttonLabel = computed(() => selectedSizeHasStock.value
  ? websiteText('productbuy').value
  : addToCartContext.outOfStockButtonLabel.value);

const fulfillmentUsps = computed(
  () => addToCartContext.product.value?.fulfillmentUsps || [],
);

const hasSizes = computed(() => addToCartContext.hasSizes.value);

function addToCart() {
  addToCartContext.addSelectedToCart();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(hasSizes))
        ? (_openBlock(), _createBlock(SizeDropdown, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["primary-button embedded-add-to-cart__add-to-cart", {
            'embedded-add-to-cart__add-to-cart--coming-soon': _unref(isComingSoon),
          }]),
          onClick: addToCart,
          disabled: !_unref(selectedSizeHasStock)
        }, _toDisplayString(_unref(buttonLabel)), 11, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fulfillmentUsps), (usp) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: usp }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(usp), 1),
              _createVNode(Divider)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fulfillmentUsps), (usp) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: usp }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(usp), 1),
          _createVNode(Divider)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})